// This is an indirect file to import the tokens string
// It needs to be a js file so that tsc doesn't complain
import tokens from './lib/Solidity.tokens'
export default tokens
